import React, { useState, useEffect } from "react";
import { useStateValue } from "../stateProvider/stateProvider";
import {
  Modal,
  Input,
  List,
  Col,
  Row,
  Button,
  Icon,
  Divider,
  Typography,
} from "antd";

const { Search } = Input;
const { Text } = Typography;

const SearchDealer = (props) => {
  const [visible, setVisible] = useState(true);
  const [inputValue, setInputValue] = useState(props.name || "");
  const [searchTerm, setSearchTerm] = useState(null);
  const [filteredDealers, setFilteredDealers] = useState([]);
  const [{ allDealers }] = useStateValue();

  // Function to handle the actual search logic
  const handleSearch = (val) => {
    const term = val.trim();
    if (term.length < 3) {
      setSearchTerm(null);
      setFilteredDealers([]);
      return;
    }

    setSearchTerm(term);
    const filtered = allDealers
      .filter((el) => el.name.toLowerCase().includes(term.toLowerCase()))
      .slice(0, 50); // Limit results for performance

    setFilteredDealers(filtered);
  };

  return (
    <Modal
      title="Selecteer Dealer"
      destroyOnClose={true}
      footer={null}
      visible={visible}
      width={600}
      onCancel={() => {
        setVisible(false);
        props.onClose();
      }}
    >
      <Search
        placeholder="Zoek dealer (min. 3 tekens)"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onSearch={handleSearch}
        enterButton
        style={{ marginBottom: 16 }}
      />

      <List
        locale={{ emptyText: searchTerm ? "Geen resultaten gevonden" : null }}
      >
        {/* Registered Dealers Section */}
        {filteredDealers.length > 0 && (
          <>
            <Divider orientation="left" style={{ margin: "12px 0" }}>
              Geregistreerde dealers
            </Divider>
            {filteredDealers.map((el, index) => (
              <List.Item key={index}>
                <List.Item.Meta
                  style={{ width: "100%" }}
                  description={
                    <Row type="flex" justify="space-between" align="middle">
                      <Col>
                        <Text>{el.name}</Text>
                      </Col>
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          onClick={() => {
                            props.onSelect({ dealer: el });
                            setVisible(false);
                            props.onClose();
                          }}
                        >
                          <Icon type="check" />
                        </Button>
                      </Col>
                    </Row>
                  }
                />
              </List.Item>
            ))}
          </>
        )}

        {/* Unregistered Dealer Section */}
        {searchTerm && (
          <>
            <Divider orientation="left" style={{ margin: "12px 0" }}>
              Ongeregistreerde dealer
            </Divider>
            <List.Item>
              <List.Item.Meta
                style={{ width: "100%" }}
                description={
                  <Row type="flex" justify="space-between" align="middle">
                    <Col>
                      <Text strong>{searchTerm}</Text>
                    </Col>
                    <Col>
                      <Button
                        shape="circle"
                        onClick={() => {
                          props.onSelect({
                            dealer: null,
                            dealerName: searchTerm,
                          });
                          setVisible(false);
                          props.onClose();
                        }}
                      >
                        <Icon type="check" />
                      </Button>
                    </Col>
                  </Row>
                }
              />
            </List.Item>
          </>
        )}
      </List>
    </Modal>
  );
};

export default SearchDealer;
